import { ListSortDirection, Sort } from "../../models/api/sort";
import { CountryDTO, CountrySTO } from "../../models/countries";
import { BaseApiService } from "../base/base-api.service";

export class CountriesApiService extends BaseApiService<CountryDTO, CountrySTO> {
  constructor() {
    super({
      servicePath: "/Countries",
      loadItemsPath: "/GetCountries",
      saveItemsPath: "/SaveCountries",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
